import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { background, button, divider, text } from "@/theme/colors";
import { toNumber } from "@/utils/number";
import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC } from "react";

type Props = {
  totalPage: number;
  page: number;
  onChangePage: (page: number) => void;
};

export const ControlledPagination: FC<Props> = ({ totalPage, page, onChangePage }) => {
  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={totalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          return (
            <PaginationItem
              {...item}
              onClick={() => {
                if (item.page == null) return;
                onChangePage(toNumber(item.page));
              }}
              slots={{ first: IconChevronsLeft, last: IconChevronsRight }}
            />
          );
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)(() => ({
  "& .MuiPaginationItem-root": {
    border: `2px solid ${divider.high}`,
    borderRadius: 8,
    minWidth: 40,
    height: 40,
    fontSize: 14,
    fontWeight: 500,
    color: text.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: button.primary,
    color: text.white,
    border: "none",
    "&:hover": {
      backgroundColor: button.primary,
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    border: "2px solid transparent",
    minWidth: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    fontWeight: 500,
    color: text.primary,
  },
  "& .MuiPaginationItem-root.Mui-disabled": {
    border: "2px solid transparent",
    backgroundColor: background.disable,
    color: text.tertiary,
    pointerEvents: "none",
  },
}));
